import { URL, API_URL } from 'utils/constants';

export const GET = 'GET';
export const POST = 'POST';
export const PUT = 'PUT';

export { URL, API_URL };
